const { setMetadata } = require('@vonage/media-processor');
const { createVonageMediaProcessorConnector } = require('@vonage/ml-transformers');

// This is copy pasta from @vonage/media-processor, basically.  The only
// difference is their's is an async call, whereas this one is synchronous.
const isSupported = () =>
  typeof MediaStreamTrackProcessor !== 'undefined' && typeof MediaStreamTrackGenerator !== 'undefined';

// Vonage's low-level machine-learning-based media processor libraries
const ML = {
  isSupported,
  setMetadata,
  createConnector: createVonageMediaProcessorConnector,
};

module.exports = ML;
